import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  question: '¿Cuánto tiempo tarda el proceso de reparación?',
  answer: 'No podemos establecer una duración exacta porque cada proceso es diferente y toma tiempos distintos. Hay casos que pueden resolverse completamente en 45 días y otros que pueden tomar más tiempo; todo depende de la complejidad del caso. Pero la garantía es clara: tenemos 120 días para entregarte una mejora y, si no lo logramos, te devolvemos el 100% de tu inversión.'
}, {
  question: '¿Cómo funciona la garantía de 120 días?',
  answer: 'Si después de 120 días no logramos alguna mejora visible en tu reporte, te devolvemos el 100% de tu inversión. Sin preguntas, sin letras pequeñas. Es nuestra forma de respaldar la calidad de nuestro servicio.'
}, {
  question: '¿Realmente pueden conseguirme $50,000 en financiamiento?',
  answer: 'Podemos hacerlo, siempre y cuando el perfil de crédito esté optimizado, sin cuentas negativas y con toda la estructura. En nuestro servicio te mostramos cómo lograrlo para poder acceder a capital.'
}, {
  question: '¿Qué tipo de ítems pueden remover de mi reporte?',
  answer: 'Podemos disputar y remover errores, cuentas en colección, late payments, charge-offs, repossessions, bankruptcies y cualquier ítem que no esté reportado correctamente según la Fair Credit Reporting Act.'
}, {
  question: '¿Es legal lo que hacen?',
  answer: 'Totalmente. Operamos bajo la Fair Credit Reporting Act (FCRA) y la Credit Repair Organizations Act (CROA). Todos nuestros métodos son 100% legales y están respaldados por la ley federal estadounidense.'
}, {
  question: '¿Cuánto cuesta el servicio?',
  answer: 'Ofrecemos diferentes paquetes según lo que tenga tu reporte de crédito y el trabajo que haya que hacer, por eso los precios pueden variar. El diagnóstico inicial es completamente gratis y sin compromiso. Durante esa consulta te presentaremos opciones de inversión que se ajusten a tu caso.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-20 md:py-24 bg-black px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-83" data-mp="2fxvf7v2zjnse">
      <div className="max-w-4xl mx-auto" data-id="element-84" data-mp="2azk6jnoffjbr">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-85" data-mp="38l93l4smbb0w">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-86" data-mp="1n8eqb7ekqp0x">
            Preguntas Frecuentes
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight leading-[1.1]" data-id="element-87" data-mp="3uv7q45y5aywg">
            Todo lo que necesitas
            <br data-id="element-88" data-mp="2nrhsgkzrmc5" />
            <span className="italic bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-89" data-mp="7pgus1rrya2v">
              saber antes de empezar.
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-90" data-mp="hftclm87fp5b">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          delay: index * 0.05,
          ease: [0.16, 1, 0.3, 1]
        }} className="rounded-2xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/10 overflow-hidden" data-id="element-91" data-mp="me3bo7x1v9w7" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 md:p-7 text-left hover:bg-white/[0.02] transition-colors" data-id="element-92" data-mp="1wvv39bo0yyz3">
                <span className="text-lg md:text-xl font-medium text-white pr-8" data-id="element-93" data-mp="26t867eh46jwd">
                  {faq.question}
                </span>
                <div className={`shrink-0 h-9 w-9 rounded-full bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-94" data-mp="1e76l2xgxf7r0">
                  <Plus className="h-4 w-4 text-amber-400" data-id="element-95" data-mp="10egv6hya1iom" />
                </div>
              </button>

              <AnimatePresence initial={false} data-id="element-96" data-mp="vgp5zvp0oao4">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.4,
              ease: [0.16, 1, 0.3, 1]
            }} className="overflow-hidden" data-id="element-97" data-mp="372qzjz3moif7">
                    <div className="px-6 md:px-7 pb-7 text-white/60 font-light leading-relaxed text-base md:text-lg" data-id="element-98" data-mp="3gtu1120gyzf0">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}